//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopRightShare from '@/components/views/top_right_share'
export default {
    components: {
        TopRightShare
    },
    props: {
        answered_questions: Array,
        result: String,
        qrcode_img: String
    }
}
